import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import type { ContentTable } from 'pdfmake/interfaces';
import { useTranslation } from 'react-i18next';
import type { GetStandardFormFieldLabel } from 'src/hooks/forms/useFormCustomisation';

import { useLazyGetConsequencesByParentIssueId } from '@/hooks/queries';
import { createTable, tableHeaders } from '@/utils/pdf/table';

const useConsequenceExportTable = (
  issueId: string,
  getStandardFieldLabel: GetStandardFormFieldLabel
): [() => Promise<ContentTable>, boolean] => {
  const { getLabel: getCriticalityLabel } = useRating('criticality');
  const [getConsequences, getConsequencesResult] =
    useLazyGetConsequencesByParentIssueId();
  const { t: st } = useTranslation(['common'], {
    keyPrefix: 'consequences',
  });

  const createExportTable = async () => {
    const { data: consequencesData } = await getConsequences({
      parentIssueId: issueId,
    });
    const consequencesTableData = (consequencesData?.consequence ?? []).map(
      (i) => [
        i.Title,
        st('costType')[i.CostType],
        i.CostValue,
        i.Criticality ? getCriticalityLabel(i.Criticality) : '-',
        i.Description ?? '',
      ]
    );

    return createTable({
      widths: ['*', 60, 40, 70, '*'],
      body: [
        tableHeaders([
          getStandardFieldLabel('consequence', 'Title'),
          getStandardFieldLabel('consequence', 'CostType'),
          getStandardFieldLabel('consequence', 'CostValue'),
          getStandardFieldLabel('consequence', 'Criticality'),
          getStandardFieldLabel('consequence', 'Description'),
        ]),
        ...consequencesTableData,
      ],
    });
  };

  return [createExportTable, getConsequencesResult.loading];
};

export default useConsequenceExportTable;
